/* eslint-disable no-console */
import React from 'react';
import { Row, Col } from 'antd';
// import ArticleTileGlobal from 'Components/common/components/ArticleTileGlobal';
import BackIcon from '../../Components/common/assets/svgIcons/BackIcon';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import NavBarPrimary from '../../Components/layout/headers/NavBarPrimary';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import AccountPopOver from '../../Components/common/components/AccountPopOver';
import PeopleCardLarge from '../../Components/common/components/PeopleCardLarge';
import CompanyCardLarge from '../../Components/common/components/CompanyCardLarge';
import HeadingWithShowAll from '../../Components/globalSearch/components/HeadingWithShowAll';
import SectionHeading from '../../Components/globalSearch/components/SectionHeading';

const SearchDetails = function SearchDetails() {
  return (
    <>
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          <BackIcon />
          <h1 className="heading">Results</h1>
        </div>
        <div className="right-side-wrap">
          <GlobalSearch />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <div className="container">
        <HeadingWithShowAll
          leftHeading={(
            <SectionHeading>Matching People</SectionHeading>)}
          isShowAllHidden
        />
        <Row gutter={[24, 24]} className="search-distance-row">
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge follow={false} />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge follow={false} />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <PeopleCardLarge />
          </Col>
        </Row>
        <Row gutter={[24, 24]} className="search-distance-row">
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
          <Col className="gutter-row d-flex justify-content-center">
            <CompanyCardLarge />
          </Col>
        </Row>
        <Row gutter={[24, 24]} className="row-container">
          {/* <Col className="gutter-row d-flex justify-content-center" span={8}>
            <ArticleTileGlobal heroArticle />
          </Col>
          <Col className="gutter-row d-flex justify-content-center" span={8}>
            <ArticleTileGlobal heroArticle />
          </Col>
          <Col className="gutter-row d-flex justify-content-center" span={8}>
            <ArticleTileGlobal heroArticle />
          </Col>
          <Col className="gutter-row d-flex justify-content-center" span={8}>
            <ArticleTileGlobal heroArticle />
          </Col>
          <Col className="gutter-row d-flex justify-content-center" span={8}>
            <ArticleTileGlobal heroArticle />
          </Col> */}
        </Row>
      </div>
    </>
  );
};

export default SearchDetails;
